import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [pulseAnimation, setPulseAnimation] = useState(true);
  const location = useLocation();

  // ✅ Detectar si estamos en página de detalle de paquete
  const esPaqueteDetail = location.pathname.startsWith('/paquete/') || location.pathname.startsWith('/paquetes/');

  // ✅ Mostrar después de 2 segundos (para no ser intrusivo inmediatamente)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // ✅ Detener animación de pulso después de 10 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      setPulseAnimation(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  // ✅ CONFIGURACIÓN - Cambiar estos valores
  const phoneNumber = '5491171628293'; // ← REEMPLAZAR con número real
  const defaultMessage = 'Hola, necesito info sobre…\nPara poder responderte, indicá destino, fecha y cantidad de pasajeros';

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(defaultMessage);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Botón flotante */}
      <button
        onClick={handleWhatsAppClick}
        className={`fixed right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center group ${
          pulseAnimation ? 'animate-bounce' : ''
        } ${
          // ✅ En PaqueteDetail mobile: posicionar arriba de la barra
          esPaqueteDetail ? 'bottom-36 lg:bottom-6' : 'bottom-6'
        }`}
        style={{
          width: '64px',
          height: '64px',
          boxShadow: '0 8px 24px rgba(37, 211, 102, 0.4)'
        }}
        aria-label="Contactar por WhatsApp"
      >
        {/* ✅ Icono SVG de WhatsApp */}
        <svg 
          viewBox="0 0 32 32" 
          className="w-9 h-9"
          fill="white"
        >
          <path d="M16 0C7.164 0 0 7.163 0 16c0 2.816.736 5.464 2.014 7.76L.064 30.667a.667.667 0 0 0 .827.827l6.907-1.95A15.936 15.936 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333A13.277 13.277 0 0 1 8.333 27.2a.667.667 0 0 0-.546-.067l-5.134 1.45 1.45-5.133a.667.667 0 0 0-.067-.547A13.277 13.277 0 0 1 2.667 16c0-7.364 5.97-13.333 13.333-13.333S29.333 8.636 29.333 16 23.364 29.333 16 29.333z"/>
          <path d="M23.573 19.44c-.36-.18-2.127-1.047-2.457-1.167-.33-.12-.57-.18-.81.18-.24.36-.93 1.167-1.14 1.407-.21.24-.42.27-.78.09-.36-.18-1.52-.56-2.897-1.787-1.07-.954-1.793-2.133-2.003-2.493-.21-.36-.023-.554.157-.733.161-.161.36-.42.54-.63.18-.21.24-.36.36-.6.12-.24.06-.45-.03-.63-.09-.18-.81-1.95-1.11-2.67-.293-.7-.59-.605-.81-.617-.21-.01-.45-.013-.69-.013s-.63.09-.96.45c-.33.36-1.26 1.23-1.26 3s1.29 3.48 1.47 3.72c.18.24 2.54 3.88 6.157 5.443.86.373 1.533.596 2.057.763.863.274 1.65.236 2.273.143.693-.103 2.127-.87 2.427-1.71.3-.84.3-1.56.21-1.71-.09-.15-.33-.24-.69-.42z"/>
        </svg>

        {/* Tooltip al hacer hover */}
        <span className="absolute right-full mr-3 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          ¿Necesitas ayuda?
        </span>
      </button>

      {/* Badge de notificación (opcional) - También ajustar posición */}
      {pulseAnimation && (
        <div className={`fixed right-6 z-50 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center animate-pulse ${
          esPaqueteDetail ? 'bottom-[152px] lg:bottom-[88px]' : 'bottom-[88px]'
        }`}>
          1
        </div>
      )}
    </>
  );
}

export default WhatsAppButton;